import { createSelector } from 'reselect';
import { statsLeadersSelector } from './simple-selectors';

export const statsLeadersSortSelector = createSelector(
    statsLeadersSelector,
    (statsLeaders) => statsLeaders.sort
);
